import ApiConstants from "../../Constants/ApiConstant";
import { apiGet } from "../../Services/ApiService";

// export const getGlobalFilterAPI = (filters, callBack) => {
//   return async () => {
//     try {
//       let queryString = "";
//       // let userRoleName = userRole;

//       // Loop through each filter and construct the query string
//       Object.keys(filters).forEach((key) => {
//         const value = filters[key];
//         // if (key === "a_z" && value === true) {
//         //   queryString += `sort_alphabetical_asc=true`;
//         // } else if (key === "z_a" && value === true) {
//         //   queryString += `sort_alphabetical_desc=true`;
//         // } else if (key === "best_selling" && value === true) {
//         //   queryString += `best_selling_product=true`;
//         // } else if (key === "new_collection" && value === true) {
//         //   queryString += `new_collection=true`;
//         // }
//         // Append only the active (true) sorting filter or valid filters
//         if (value === true) {
//           if (key === "a_z") {
//             queryString += `sort_alphabetical_asc=true&`;
//           } else if (key === "z_a") {
//             queryString += `sort_alphabetical_desc=true&`;
//           } else if (key === "best_selling") {
//             queryString += `best_selling_product=true&`;
//           } else if (key === "new_collection") {
//             queryString += `new_collection=true&`;
//           }
//         }

//         // Skip undefined, null, or empty values (for arrays, objects, and primitive types)
//         if (
//           value === null ||
//           value === undefined ||
//           (Array.isArray(value) && value.length === 0) ||
//           (typeof value === "object" && Object.keys(value).length === 0) // Skip empty objects
//         ) {
//           return;
//         }

//         if (Array.isArray(value)) {
//           // Join array values with commas without URL encoding commas
//           // queryString += `${key}=${value.join(",")}&`;

//           // Remove duplicates from the array
//           const uniqueValues = [...new Set(value)];

//           queryString += `${key}=${uniqueValues.join(",")}&`;
//         }
//         //  else if (key === "wastageSort") {
//         //   // For wastageSort, use high_to_low or low_to_high
//         //   queryString += `high_to_low_wastage=${
//         //     value === "high-to-low" ? "true" : "false"
//         //   }&`;
//         // }
//         else if (key === "wastageSort") {
//           // Add to query string only if a valid option is selected
//           if (value === "high-to-low") {
//             queryString += `high_to_low=true&`;
//           } else if (value === "low-to-high") {
//             queryString += `low_to_high=true&`;
//           }
//         } else if (typeof value === "boolean") {
//           // For boolean values (e.g., wastageSort), use true/false
//           queryString += `${encodeURIComponent(key)}=${
//             value ? "true" : "false"
//           }&`;
//         } else if (typeof value === "object") {
//           // For objects like weightRange, handle min/max separately
//           if (key === "weightRange") {
//             // Check if weightRange contains valid min/max values
//             if (value.min_net_weight && value.min_net_weight !== "") {
//               queryString += `min_net_weight=${encodeURIComponent(
//                 value.min_net_weight
//               )}&`;
//             }
//             if (value.max_net_weight && value.max_net_weight !== "") {
//               queryString += `max_net_weight=${encodeURIComponent(
//                 value.max_net_weight
//               )}&`;
//             }
//             // If both min_net_weight and max_net_weight are missing, do not append weightRange
//             return;
//           } else if (key === "productSubcategoryId") {
//             // Handle the new product_subcategory_id query
//             queryString += `product_subcategory_id=${encodeURIComponent(
//               value
//             )}&`;
//           }
//         } else {
//           // For regular key-value pairs, append directly
//           queryString += `${encodeURIComponent(key)}=${encodeURIComponent(
//             value
//           )}&`;
//         }
//       });

//       // Remove trailing '&' from the query string
//       queryString = queryString.endsWith("&")
//         ? queryString.slice(0, -1)
//         : queryString;

//       // const apiUrl = `${ApiConstants.globalFilterUrl}?${queryString}?role_name=${userRoleName}`;
//       const apiUrl = `${ApiConstants.globalFilterUrl}?${queryString}`;

//       // return;
//       await apiGet(apiUrl)
//         .then((response) => {
//           callBack && callBack(response); // Pass data to the callback
//         })
//         .catch((err) => {
//           console.log("Error fetching global filter results:", err);
//           throw err;
//         });
//     } catch (err) {
//       console.log("Unexpected error in getGlobalFilterAPI:", err);
//       throw err;
//     }
//   };
// };

export const getGlobalFilterAPI = (filters, callBack,page = 1, recordsPerPage = 50) => {
  return async () => { 
    
    try {
      let queryString = "";

      // Loop through each filter and construct the query string
      Object.keys(filters).forEach((key) => {
        if (key === "carat") return;
        const value = filters[key];

        // Skip undefined, null, or empty values (for arrays, objects, and primitive types)
        if (
          value === null ||
          value === undefined ||
          (Array.isArray(value) && value.length === 0) ||
          (typeof value === "object" && Object.keys(value).length === 0)
        ) {
          return;
        }

        if (Array.isArray(value)) {
          // Handle array values
          const uniqueValues = [...new Set(value)]; // Remove duplicates
          queryString += `${encodeURIComponent(key)}=${uniqueValues.join(
            ","
          )}&`;
        } else if (key === "wastageSort") {
          // Handle wastageSort
          if (value === "high-to-low") {
            queryString += `high_to_low=true&`;
          } else if (value === "low-to-high") {
            queryString += `low_to_high=true&`;
          }
        } else if (typeof value === "boolean") {
          // Append true/false values only if they are true
          if (value) {
            if (key === "a_z") {
              queryString += `sort_alphabetical_asc=true&`;
            } else if (key === "z_a") {
              queryString += `sort_alphabetical_desc=true&`;
            } else if (key === "best_selling") {
              queryString += `best_selling_product=true&`;
            } else if (key === "new_collection") {
              queryString += `new_collection=true&`;
            } else {
              queryString += `${encodeURIComponent(key)}=true&`;
            }
          }
        } else if (typeof value === "object" && key === "weightRange") {
          // Handle weightRange object separately
          if (value.min_net_weight) {
            queryString += `min_net_weight=${encodeURIComponent(
              value.min_net_weight
            )}&`;
          }
          if (value.max_net_weight) {
            queryString += `max_net_weight=${encodeURIComponent(
              value.max_net_weight
            )}&`;
          }
        } else {
          // For other key-value pairs
          queryString += `${encodeURIComponent(key)}=${encodeURIComponent(
            value
          )}&`;
        }
      });

      // Remove trailing '&' from the query string
      queryString = queryString.endsWith("&")
        ? queryString.slice(0, -1)
        : queryString;

        // Append pagination info
      queryString += `&records_per_page=${recordsPerPage}&page=${page}`; 

      const apiUrl = `${ApiConstants.globalFilterUrl}?${queryString}`;
      // return apiUrl
      await apiGet(apiUrl)
        .then((response) => {
          callBack && callBack(response); // Pass data to the callback
        })
        .catch((err) => {
          console.log("Error fetching global filter results:", err);
          throw err;
        });
    } catch (err) {
      console.log("Unexpected error in getGlobalFilterAPI:", err);
      throw err;
    }
  };
};
